import React from "react";

export default () => {

    return (
        <div style={{ marginBottom: 10 }}>
            <h1 className="h1" style={{marginTop: 10 , marginBottom: 10}}>
                  Cloud Fare Posting
            </h1>
            <p style={{ fontSize: 14, lineHeight: 1.3, marginBottom: 50 }}>
                A simple react app to user workers API
            </p>
        </div>
    );
};
